// Freeze cached objects before returning to ensure reliability of data/to prevent bugs
function deepFreeze(obj) {
  if (obj && typeof obj === 'object' && !Object.isFrozen(obj)) {
    Object.freeze(obj);
    Object.getOwnPropertyNames(obj).forEach(prop => {
      deepFreeze(obj[prop]);
    });
  }
  return obj;
}

export function getCacheKey(method, url, params) {
  return `apiCache_${method}_${url}_${JSON.stringify(params || {})}`;
}

export function isCacheValid(cacheEntry, duration, currentUserId) {
  if (!cacheEntry) return false;

  const { timestamp, userId } = cacheEntry;

  return (
    userId === currentUserId &&
    (Date.now() - timestamp) < duration
  );
}

export function getCache(key) {
  const cached = localStorage.getItem(key);
  if (!cached) return null;

  try {
    return JSON.parse(cached); 
  } catch (err) {
    console.warn("Failed to parse cache:", err);
    return null;
  }
}

export function setCache(key, data, { userId, freeze = true } = {}) {
  const finalData = freeze ? deepFreeze(data) : data;

  localStorage.setItem(key, JSON.stringify({
    data: finalData,
    timestamp: Date.now(),
    userId
  }));
}

export function clearCache(key) {
  localStorage.removeItem(key);
}

export function clearAllCache() {
  Object.keys(localStorage)
    .filter(key => key.startsWith("apiCache_"))
    .forEach(key => localStorage.removeItem(key));
}